module.exports = __webpack_public_path__ + "Aspira-Medium-f93e75ac24.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Aspira-Medium.ttf
// module id = 10
// module chunks = 8